import React from "react";
import { useFxConversionBasis, describeFxBasis } from "../data/useFxConversionBasis.js";
import { T } from "../app/tokens.js";

export function FxBasisCaption({ testId = "fx-basis-caption", style, prefix = "USD at" }) {
  const { basis, rates, loading, error } = useFxConversionBasis();
  const label = loading ? "Loading basis…" : error ? "Basis unavailable" : describeBasisCaption(basis);
  const detail = error || loading ? label : describeFxBasis(basis, rates);

  return (
    <span
      data-testid={testId}
      tabIndex={0}
      title={detail}
      aria-label={`${prefix} ${label}. Rate details: ${detail}`}
      style={{
        color: T.mid,
        fontSize: T.fsXs,
        lineHeight: 1.4,
        cursor: "help",
        ...style,
      }}
    >
      {prefix} {label}
      {" "}
      <a
        href="/currency-rates"
        aria-label="View currency rates and saved basis details"
        title="View currency rates and saved basis details"
        style={{ color: T.mid, textDecoration: "underline", textUnderlineOffset: 2 }}
      >
        View rates
      </a>
    </span>
  );
}

function describeBasisCaption(basis) {
  if (!basis) return "unavailable";
  if (basis.mode === "as_of") return `as of ${basis.asOfDate}`;
  if (basis.mode === "budget") return `FY${String(basis.fiscalYear).slice(-2)} budget`;
  return "live";
}
